var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190",
    enableBackground: "new 0 0 190 190",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#D1D1D1",
    cx: 213.5,
    cy: 66.25,
    r: 77.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 193.501,
    cy: 56.25,
    r: 77.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Instructions_and_Tone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EAEAEA",
    cx: 105.501,
    cy: 102.25,
    r: 77.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000162312701274348272200000003348905186042151084_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE149",
    d: "M73.255,125.164c1.103,2.366,2.578,4.651,4.698,6.32c2.12,1.668,4.961,2.652,7.613,2.184 c6.583-1.162,6.582-14.74,7.945-19.781c2.546-9.418,5.092-18.838,7.639-28.255c5.004-18.513,10.009-37.024,15.014-55.537 c1.17-4.328,2.284-9.145-0.004-13.186c-1.487-2.626-4.176-4.454-6.773-6.17c-6.928-4.578-14.853-9.319-23.04-8.148 c-12.032,1.722-17.33,14.726-19.459,25.951c-3.069,16.185-4.043,32.784-2.961,49.333C64.926,93.153,66.578,110.837,73.255,125.164 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE149",
    d: "M78.499,154.355c-5.027,1.808-9.329,8.193-8.365,14.74c1.441,9.791,11.276,11.79,17.631,9.798 c7.148-2.24,11.69-14.103,5.417-21.16C89.475,153.562,82.928,152.762,78.499,154.355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M60.848,167.234c-0.265,0-0.534-0.043-0.798-0.135C28.319,156.157,7.001,126.24,7.001,92.656 c0-32.547,20.446-62.148,50.878-73.66c1.266-0.477,2.678,0.159,3.155,1.423c0.479,1.264-0.158,2.677-1.422,3.156 C31.072,34.37,11.896,62.133,11.896,92.656c0,31.496,19.993,59.554,49.75,69.815c1.278,0.441,1.956,1.834,1.516,3.112 C62.812,166.596,61.862,167.234,60.848,167.234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M104.553,169.042c-1.093,0-2.089-0.738-2.371-1.846c-0.332-1.311,0.46-2.643,1.77-2.975 c32.741-8.312,55.607-37.74,55.607-71.565c0-25.124-12.601-48.297-33.707-61.988c-1.134-0.735-1.458-2.251-0.721-3.385 c0.735-1.134,2.25-1.457,3.385-0.722c22.503,14.598,35.938,39.306,35.938,66.095c0,36.066-24.384,67.446-59.297,76.31 C104.956,169.017,104.753,169.042,104.553,169.042"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_01_Urgent.9362e0b1.svg";
export { SvgComponent as ReactComponent };